import { render, staticRenderFns } from "./RentalObjectProspectDetailsMessages.vue?vue&type=template&id=420c58e7&scoped=true&"
import script from "./RentalObjectProspectDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./RentalObjectProspectDetailsMessages.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectProspectDetailsMessages.vue?vue&type=style&index=0&id=420c58e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420c58e7",
  null
  
)

export default component.exports